import React from 'react';
import styled from '@mui/material/styles/styled';
import Paper from '@mui/material/Paper';
import NotificationCard from './components/NotificationCard';
import NoNotificationPage from './components/NoNotifications';
import configs from './config';
import './App.css';

// the milisecond difference between Browser datetime to UTC
// const CurrentTimeZoneDate = new Date().getTimezoneOffset() * 60 * 1000;

/**
 * @example
 * Show Time with below structure
 * 7:49 PM
 * @param {number} date
 * @returns string
 */
function currentTimeHM(date) {
  return new Intl.DateTimeFormat('default', {
    hour: 'numeric',
    minute: 'numeric',
    second: undefined,
    hour12: true,
  }).format(date);
}

/**
 * @example
 * Show Date with below structure
 * 19 Sep 2022
 * @param {number} date
 * @returns string
 */
function currentDate(date) {
  let result = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
  if (result.includes('Sept')) result = result.replace('Sept', 'Sep');
  return result;
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: 'transparent',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'left',
  // color: grey[100], // theme.palette.text.primary,
  margin: 0,
  Width: '90%', // '375px',
}));

const makeRead = (notificationId) => {
  // const Id = notificationData.findIndex(value.id === notificationId)
  // eslint-disable-next-line no-console
  console.log('from parent', { notificationId });
};

const NotificationSettings = async (command, token) => {
  const requestJSON = await (
    await configs.BaseAxios.get(`settings/${command}`, {
      headers: {
        'x-btz-token': token,
      },
    })
  ).data;
  const settings = JSON.stringify(requestJSON.result);
  // eslint-disable-next-line no-console
  console.log(settings);
  // eslint-disable-next-line no-undef
  nativeApp.openNotification(settings);
  // if (settings) window.postMessage(JSON.stringify(settings));
};

let showdate = false;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageItems: 10,
      notificationData: [],
      dateGroups: [],
      start: 0,
      dataIsReturned: false,
      token: '',
    };
  }

  componentDidMount() {
    window.localStorage.removeItem('token');

    const getTokenInterval = setInterval(() => {
      if (window.localStorage.getItem('token')) {
        const token = window.localStorage.getItem('token');
        this.setState({ token }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          if (token) {
            // console.log({ token });
            const {
              params: { applicationId, userId },
            } = this.props;
            // convert message.Date which is UTC to device current timezone
            configs.BaseAxios.get(`/${userId}/${applicationId}`, {
              headers: {
                'x-btz-token': token,
              },
            }).then((res) => {
              const rawNotificationData = res.data.result;
              rawNotificationData.forEach((message, index) => {
                rawNotificationData[index].Date_Sent = currentDate(
                  Number(message.Date)
                );
                rawNotificationData[index].Time_Sent = currentTimeHM(
                  Number(message.Date)
                );
              });
              this.setState(
                { notificationData: [...rawNotificationData] },
                this.setState({ dataIsReturned: true })
              );
            });
          }
        });
        // eslint-disable-next-line react/destructuring-assignment
        clearInterval(getTokenInterval);
      }
    }, 100);

    // const { applicationId, userId } = this.props?.params;
    // eslint-disable-next-line react/destructuring-assignment
    // if (this.state.tokenIsAvaliable) {

    // }
  }

  render() {
    const {
      params: { applicationId },
    } = this.props;
    const { notificationData, dataIsReturned, start, pageItems, dateGroups } =
      this.state;
    const isGlobal = applicationId === '1';
    document.body.style = isGlobal
      ? `background-color: #090916; background-repeat: repeat; background-size:fill`
      : `background-color: #050505; background-repeat: repeat; background-size:fill`;
    return !dataIsReturned ? (
      <h1> </h1>
    ) : (
      <div className="stackmain">
        {!notificationData.length ? (
          <div style={{ marginTop: '215px' }}>
            <NoNotificationPage appId={isGlobal} />
          </div>
        ) : (
          notificationData
            .sort((a, b) => b.Date - a.Date)
            .slice(0, start + pageItems)
            .map((value) => {
              showdate = false;
              if (!dateGroups.includes(value.Date_Sent)) {
                dateGroups.push(value.Date_Sent);
                showdate = true;
              }
              return (
                <Item
                  key={value.Date}
                  onClick={() =>
                    // eslint-disable-next-line react/destructuring-assignment
                    NotificationSettings(value.Command, this.state.token)
                  }
                  style={{
                    boxShadow: 'none',
                  }}
                >
                  {showdate && (
                    <div
                      style={{
                        color: '#B7B7B7',
                        fontSize: '12px',
                        fontWeight: '400',
                        marginBottom: '4px',
                        backgroundColor: 'transparent',
                        border: '0px',
                        lineHeight: '18.26px',
                      }}
                    >
                      {' '}
                      {value.Date_Sent}{' '}
                    </div>
                  )}{' '}
                  <NotificationCard
                    onRead={makeRead}
                    notificationId={value.Id}
                    notificationTitle={value.Message_Title}
                    notificationBody={value.Message_Body}
                    notificationTime={value.Time_Sent}
                    isRead={value.Is_Read}
                    btztoken={window.localStorage.getItem('token')}
                    isGlobal={isGlobal}
                  />
                </Item>
              );
            })
        )}
        {start + pageItems < notificationData?.length && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div
            key="more"
            style={{
              alignContent: 'center',
              verticalAlign: 'center',
              textAlign: 'center',
              color: '#10F48B',
              cursor: 'pointer',
              marginBottom: '16px', // was 20px
              marginTop: '16px', // was 20px
              fontSize: '16px',
              fontWeight: '700',
              lineHeight: '20.86px',
            }}
            // window.scrollTo(0, 0); // scroll to the upper side of the page
            onClick={() => {
              dateGroups.length = 0;
              this.setState({ start: start + pageItems });
            }}
          >
            Show more
          </div>
        )}
      </div>
    );
  }
}

export default App;
